import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unselected_coupons",
  "use": "icon-unselected_coupons-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-unselected_coupons\">\n  <defs>\n    <style>\n      #icon-unselected_coupons .cls-1 {\n        fill: none;\n        stroke: currentColor;\n        stroke-width: 2px;\n      }\n    </style>\n  </defs>\n  <circle id=\"icon-unselected_coupons_unselected_coupons\" class=\"cls-1\" cx=\"18\" cy=\"18\" r=\"17\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol